module.exports = __webpack_public_path__ + "assets/img/Eliz.882d146a.jpg";